import styled from 'styled-components';
import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;

  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;

  @media (max-width: 1199px) {
    flex-direction: column;
  }
`;

export const PageTitle = styled.h1`
  font-size: 40px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.02em;
  margin-bottom: 4px;
`;

export const TitleAccent = styled.span`
  color: ${colors.primary};
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  color: ${colors.onSurfaceVariant};
  max-width: 460px;
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  padding: 14px 28px;

  background-color: ${colors.primary};
  border: none;
  border-radius: ${radius.full};
  cursor: pointer;

  color: ${colors.onPrimary};
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;

  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 0 24px ${colors.primary}40;
  }

  &:disabled {
    background-color: ${colors.surfaceContainerLow};
    color: ${colors.onSurfaceVariant};
    cursor: default;
    box-shadow: none;
  }
`;

export const Content = styled.div`
  flex: 1;

  display: grid;
  grid-gap: 20px;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (max-width: 1400px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 800px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const FichaCard = styled.div`
  padding: 24px;

  background-color: ${colors.surfaceContainerLow};
  border-radius: ${radius.md};
  cursor: pointer;

  display: flex;
  flex-direction: column;

  transition: background-color 0.2s;

  &:hover {
    background-color: ${colors.surfaceContainer};
  }
`;

export const FichaCardHead = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`;

export const FichaCardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const RemoveFichaButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 4px;
  color: ${colors.onSurfaceVariant};

  &:hover {
    color: ${colors.error};
  }
`;

export const FichaName = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: ${colors.onSurface};
  letter-spacing: -0.01em;
`;

export const FichaFocus = styled.span`
  display: inline-block;
  margin-top: 6px;

  padding: 3px 10px;
  border-radius: ${radius.full};

  background-color: ${colors.primary}1f;
  color: ${colors.primary};

  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`;

export const SplitList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  margin: 16px 0;
`;

export const SplitRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
`;

export const SplitBadge = styled.span`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: ${radius.sm};

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${colors.primary}1f;
  color: ${colors.primary};

  font-size: 11px;
  font-weight: 700;
`;

export const SplitTitle = styled.span`
  color: ${colors.onSurfaceVariant};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FichaFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  padding-top: 16px;
  border-top: 1px solid ${colors.outlineVariant}1a;

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${colors.onSurfaceVariant};
`;

export const CreateFichaCard = styled.button`
  width: 100%;
  min-height: 220px;
  padding: 28px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;

  background: transparent;
  border: 2px dashed ${colors.outlineVariant}80;
  border-radius: ${radius.md};
  cursor: pointer;

  color: ${colors.onSurfaceVariant};

  transition: color 0.2s, border-color 0.2s;

  span.label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
  }

  &:hover {
    color: ${colors.primary};
    border-color: ${colors.primary}60;
  }
`;
